import { favouriteSortFilters } from "../Constants";

const initialState = {
    data:[],
    pageNo:0,
    sortFilter:favouriteSortFilters[0],
    sortChange:false,
    domains:[],
    isLoading:false,
    totalCount:0,
    refresh:'refreshed',
    reload:'random',
    searchQuery:'',
    sortOptions: favouriteSortFilters,
    relevanceObj : {id:'3',value:"3",label:"Relevance", origValue:'relevance', sortOrder:'asc'},

}

const favouritePageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "updateFavouriteSearchedQuery":
      state = {...state, pageNo:0};
      state = {...state, data:[]};
      state = {...state, searchQuery:payload};
      return state;
    case "updateFavouriteDomainValue":
      state = {...state, pageNo:0};
      state = {...state, data:[]};
      state = {...state, sortChange:true};
      state = {...state, domains:payload};
      return state;
    case "updateFavouriteSortFilterValue":
      state = {...state, pageNo:0};
      state = {...state, data:[]};
      state = {...state, sortChange:true};
      state ={...state, sortFilter:payload};
      return state;
    case 'reloadFavouritetab':
      state = {...state,reload:payload };
      return state;
    case 'IsLoadingFavouritetab':
      state = {...state,isLoading:payload };
      return state;
    case 'updateFavouriteTabData':
      if(payload.value === undefined)
      {
      let newData = [];
      if(state.pageNo === 0){
        newData = payload.data;
      }else{
        newData = state.data.concat(payload.data);
      }
      state = {...state, totalCount:payload.count}
      state = {...state, data: newData};
      }
      else
      state = {...state, totalCount:payload.count}
      state = {...state, data:payload.data}
      return state;
    case 'updatePageNoFavourite':
      let randomVal = Math.random()*10;
      if(payload === 0){
        state = {...state, reload:randomVal.toString() }
        state = {...state, data:[]};
      }
      state = {...state, sortChange:false};
      state = {...state, pageNo:payload};
      return state;
    case 'markedFavData':
      let filtered = payload.filter((data) => {
        if (data.favourite ) {
          return data;
        }
      });
      state ={...state, totalCount:state.totalCount-1}
      state = {...state,data:filtered };
      return state;
    case 'updateSortFilterFT':
      state = {...state,sortOptions:payload };
      return state;
  default:
    return state
  }
}

export default favouritePageReducer;
